import { Quote } from "lucide-react";
import { withDefaults } from "@/lib/sections";
import { SectionShell, SectionHeading, Img } from "./shared";

export const TestimonialsSection = ({ id, content }) => {
  const c = withDefaults("testimonials", content);
  return (
    <SectionShell id={`s-${id}`} testId={`custom-section-${id}`}>
      <SectionHeading eyebrow={c.eyebrow} title={c.title} />
      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {(c.items || []).map((t, i) => (
          <blockquote key={i} className="flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-6">
            <Quote className="h-6 w-6 text-orange-500" />
            <p className="mt-4 flex-1 leading-relaxed text-slate-300">“{t.quote}”</p>
            <footer className="mt-6 flex items-center gap-3">
              {t.photo ? (
                <Img src={t.photo} className="h-10 w-10 rounded-full object-cover" />
              ) : (
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-orange-500/15 font-semibold text-orange-400">{(t.name || "?")[0]}</span>
              )}
              <div>
                <p className="text-sm font-semibold text-white">{t.name}</p>
                <p className="font-mono text-xs text-slate-500">{t.role}</p>
              </div>
            </footer>
          </blockquote>
        ))}
      </div>
    </SectionShell>
  );
};

export default TestimonialsSection;
